import React, {ReactElement, useEffect, useState} from 'react'
import styles from './index.module.scss'


interface OvalSwitcherItemProps {
    id: string,
    title: string,
    initialActive?: boolean,
    icon?: ReactElement,
}

interface OvalSwitcherProps {
    itemList: OvalSwitcherItemProps[]
    onChange?: (id: string) => void
    defaultActiveId?: string
    activeId?: string
}


export default function OvalSwitcher({ itemList, onChange, defaultActiveId, activeId }: OvalSwitcherProps){
    const [active, setActive] = useState(activeId || defaultActiveId || itemList[0].id)

    useEffect(() => {
        if (activeId) {
            setActive(activeId)
        }
    }, [activeId])

    const handleClick = (id: string) => {
        setActive(id)
        onChange?.(id)
    }

    return(
        <div className={styles.ovalSwitcher}>
            {itemList.map((item: OvalSwitcherItemProps) => (
                <div key={item.id} className={`${styles.ovalSwitcher__item} ${active === item.id && styles.active}`} onClick={() => handleClick(item.id)}>
                    {item.icon}
                    {item.title}
                </div>
            ))}

        </div>
    )
}
